import { format } from "date-fns";

import { ManufacturerFilter, ManufacturerFilterProps } from "src/pages/manufacturer/types";
import { UserType } from "src/types/users";



export const getDefaultManFilters = (searchParams: URLSearchParams, userData: UserType | null, type: string): ManufacturerFilterProps => {
  return {
    start_date:
      searchParams.get("start_date") || 
      format(new Date().setDate(new Date().getDate() - 30), "yyyy-MM-dd"),
    end_date:
      searchParams.get("end_date") ||
      format(new Date().setDate(new Date().getDate() + 1), "yyyy-MM-dd"),
    period: searchParams.get('period') || "day",
    filter_type: searchParams.get("filter") || "",
    type: type,
    user_id: searchParams.get("id") || (userData ? userData.id.toString() : ""),
    role: searchParams.get("role") || (userData ? userData.ref_type.toLowerCase() : "manufacturer"),
    insurance_name: searchParams.get("insurance_name") || "",
  }
}

export const areManFiltersUpdated = (latestParams: ManufacturerFilterProps, searchParams: URLSearchParams, userData: UserType | null, type: string): boolean => {
  const initialParams = getDefaultManFilters(searchParams, userData, type)
  return Object.keys(latestParams).some((key: unknown) => {
    return latestParams[key as ManufacturerFilter] !== initialParams[key as ManufacturerFilter]
  })
}
